<template>
  <aside class="inspector" aria-label="تنظیمات">
    <header class="ins-head">
      <span class="ins-kind" :class="'k-' + target.kind"><VnIcon :name="headIcon" /></span>
      <div><small>{{ headKicker }}</small><b>{{ headTitle }}</b></div>
      <button v-if="target.kind !== 'form'" type="button" class="ins-close" title="تنظیمات فرم" @click="$emit('select', { kind: 'form' })"><VnIcon name="x" /></button>
    </header>

    <div class="ins-body">
      <!-- form -->
      <div v-if="target.kind === 'form'" class="ins-pane">
        <label class="ins-field"><span>{{ kind === 'visit' ? 'نام نوع ویزیت' : 'نام پرسشنامه' }}</span><input v-model="form.verbose_name" maxlength="40" /></label>
        <label class="ins-field"><span>نام لاتین (کد) <small>برای گزارش‌ها و یکپارچه‌سازی</small></span><input v-model="form.title" maxlength="40" dir="ltr" /></label>
        <template v-if="kind === 'visit'">
          <label class="ins-field"><span>توضیح</span><textarea v-model="form.description" rows="2" /></label>
          <label class="ins-field"><span>دسته‌ی فروشگاه</span>
            <select v-model="form.outlet_category"><option :value="null" disabled>انتخاب کنید</option><option v-for="item in catalog.outlet_categories" :key="item.id" :value="item.id">{{ item.verbose_name || item.name }}</option></select>
          </label>
          <label class="ins-toggle"><input v-model="form.has_supervision" type="checkbox" /><span><b>سرکشی دارد</b><small>سرپرست‌ها مرحله‌های جداگانه‌ی سرکشی را پر می‌کنند.</small></span></label>
          <label class="ins-toggle"><input v-model="form.is_active" type="checkbox" /><span><b>فعال</b><small>نوع غیرفعال برای برنامه‌ریزی ویزیت تازه پیشنهاد نمی‌شود.</small></span></label>
          <fieldset v-if="catalog.surveys.length" class="ins-box"><legend>پرسشنامه‌های همراه ویزیت</legend>
            <div class="ins-chips wrap">
              <label v-for="item in catalog.surveys" :key="item.id" :class="{ active: form.surveys.includes(item.id) }"><input v-model="form.surveys" type="checkbox" :value="item.id" />{{ item.verbose_name || item.name }}</label>
            </div>
          </fieldset>
        </template>
        <template v-else>
          <label class="ins-toggle"><input v-model="form.is_active" type="checkbox" /><span><b>فعال</b><small>پرسشنامه‌ی غیرفعال در اپ دیده نمی‌شود.</small></span></label>
          <label class="ins-toggle"><input v-model="form.has_phone_verification" type="checkbox" /><span><b>تأیید شماره‌ی پاسخ‌دهنده</b><small>پیش از ثبت، کد پیامکی به پاسخ‌دهنده فرستاده می‌شود.</small></span></label>
          <label v-if="form.has_phone_verification" class="ins-field"><span>متن پیامک</span><textarea v-model="form.sms_text" rows="2" maxlength="255" /></label>
          <label class="ins-field"><span>نماد (نشانی تصویر)</span><input v-model="form.icon" dir="ltr" placeholder="https://…" /></label>
        </template>
        <fieldset v-if="catalog.add_ins.length" class="ins-box"><legend>افزونه‌ها</legend>
          <div class="ins-chips wrap">
            <label v-for="item in catalog.add_ins" :key="item.id" :class="{ active: form.add_ins.includes(item.id) }"><input v-model="form.add_ins" type="checkbox" :value="item.id" />{{ item.verbose_name || item.key }}</label>
          </div>
        </fieldset>
      </div>

      <!-- section -->
      <div v-else-if="target.kind === 'section'" class="ins-pane">
        <label class="ins-field"><span>عنوان بخش</span><input ref="first" v-model="item.verbose_name" maxlength="40" /></label>
        <label class="ins-field"><span>کد بخش <small>لاتین؛ دو حرف اول، نوع پرسش‌ها را می‌سازد</small></span><input v-model="item.name" maxlength="30" dir="ltr" :placeholder="item.id ? '' : 'خودکار'" /></label>
        <label class="ins-field"><span>توضیح</span><textarea v-model="item.description" rows="2" /></label>
        <label class="ins-field"><span>دسته‌ی گزارش</span>
          <select v-model="item.report_category"><option :value="null">بدون دسته</option><option v-for="row in reportOptions" :key="row.id" :value="row.id">{{ row.verbose_name || row.name }}</option></select>
        </label>
        <label class="ins-toggle"><input v-model="item.is_mandatory" type="checkbox" /><span><b>بخش اجباری</b><small>همه‌ی پرسش‌های این بخش اجباری حساب می‌شوند.</small></span></label>
        <label class="ins-toggle"><input v-model="item.is_active" type="checkbox" /><span><b>فعال</b><small>بخش غیرفعال در اپ دیده نمی‌شود.</small></span></label>
      </div>

      <!-- question -->
      <QuestionSettings v-else-if="target.kind === 'question'" :question="item" :kind="kind" :types="catalog.answer_types" :types-by-id="typesById"
                        :presets="catalog.validations" :products="catalog.products" :photos="photos"
                        @select-photo="photo => $emit('select', { kind: 'photo', item: photo })" @add-photo-for="question => $emit('add-photo-for', question)" />

      <!-- photo step -->
      <div v-else-if="target.kind === 'photo'" class="ins-pane">
        <p v-if="item.photos" class="ins-note"><b class="vn-num">{{ fa(item.photos) }}</b> تصویر در این مرحله ثبت شده است؛ حذف آن را بایگانی می‌کند.</p>
        <label class="ins-field"><span>عنوان مرحله</span><input ref="first" v-model="item.verbose_name" maxlength="40" /></label>
        <label class="ins-field"><span>راهنمای عکاسی <small>در اپ کنار دکمه‌ی دوربین دیده می‌شود</small></span><textarea v-model="item.description" rows="2" placeholder="مثلاً: از روبه‌رو و با نور کافی عکس بگیرید." /></label>
        <div class="ins-grid">
          <label class="ins-field"><span>کمترین تصویر</span><input v-model.number="item.min" type="number" min="0" dir="ltr" /></label>
          <label class="ins-field"><span>بیشترین تصویر</span><input v-model.number="item.max" type="number" min="1" dir="ltr" /></label>
        </div>
        <label class="ins-toggle"><input v-model="item.is_mandatory" type="checkbox" /><span><b>اجباری</b><small>ویزیت بدون حداقل تصویر این مرحله ارسال نمی‌شود.</small></span></label>
        <label v-if="kind === 'visit' && track === 'visit'" class="ins-toggle"><input :checked="item.name === entryPhoto" type="checkbox" @change="toggleEntry($event.target.checked)" />
          <span><b>تصویر ورود</b><small>نخستین تصویر این مرحله، زمان شروع ویزیت را ثبت می‌کند.</small></span></label>
        <label v-if="kind === 'visit' && track === 'visit'" class="ins-toggle"><input v-model="item.ai_shelf_enabled" type="checkbox" />
          <span><b>شمارش فیس شلف با هوش مصنوعی</b><small>کارشناس پس از گرفتن عکس، برند یا محصول را انتخاب و شمارش پیشنهادی را بررسی می‌کند.</small></span></label>
        <label class="ins-field"><span>پرسش مرتبط</span>
          <select v-model="item.question">
            <option :value="null">بدون پرسش</option>
            <option v-if="item.question && !questionOptions.some(row => row.ref === item.question)" :value="item.question">پرسشی بیرون از این فرم</option>
            <optgroup v-for="group in questionGroups" :key="group.key" :label="group.label">
              <option v-for="row in group.rows" :key="row.ref" :value="row.ref">{{ row.text }}</option>
            </optgroup>
          </select>
        </label>
        <label class="ins-field"><span>دسته‌ی گزارش</span>
          <select v-model="item.report_category"><option :value="null">بدون دسته</option><option v-for="row in reportOptions" :key="row.id" :value="row.id">{{ row.verbose_name || row.name }}</option></select>
        </label>
        <label class="ins-field"><span>کد مرحله <small>لاتین</small></span><input v-model="item.name" maxlength="30" dir="ltr" :disabled="item.name === entryPhoto" :placeholder="item.id ? '' : 'خودکار'" /></label>
        <label class="ins-toggle"><input v-model="item.is_active" type="checkbox" /><span><b>فعال</b></span></label>
      </div>
    </div>
  </aside>
</template>

<script>
import VnIcon from '@/components/VnIcon/index.vue';
import QuestionSettings from './QuestionSettings.vue';
import { fa, questionRef } from '../designerModel';

export default {
  name: 'Inspector',
  components: { VnIcon, QuestionSettings },
  props: {
    target: { type: Object, required: true },
    tree: { type: Object, required: true },
    track: { type: String, default: 'visit' },
    catalog: { type: Object, required: true },
    typesById: { type: Object, required: true },
  },
  data: () => ({ previousName: '' }),
  computed: {
    kind() { return this.tree.kind; },
    form() { return this.tree.form; },
    item() { return this.target.item; },
    entryPhoto() { return this.catalog.entry_photo || 'StoreFront'; },
    photos() { return this.tree.tracks[this.track].photos; },
    headIcon() { return { form: this.kind === 'visit' ? 'audit' : 'survey', section: 'section', question: 'edit', photo: 'camera' }[this.target.kind]; },
    headKicker() { return { form: 'تنظیمات فرم', section: 'بخش', question: 'پرسش', photo: 'مرحله‌ی تصویر' }[this.target.kind]; },
    headTitle() {
      if (this.target.kind === 'form') return this.form.verbose_name || 'بی‌نام';
      if (this.target.kind === 'question') return this.item.text ? this.item.text.slice(0, 60) : 'پرسش تازه';
      return this.item.verbose_name || 'بی‌نام';
    },
    reportOptions() {
      if (this.kind === 'survey') return this.catalog.survey_report_categories;
      const supervision = this.track === 'supervision';
      return this.catalog.report_categories.filter(row => (!row.visit_type || row.visit_type === this.form.id) && !!row.is_for_supervision === supervision);
    },
    questionOptions() {
      return Object.values(this.tree.tracks).flatMap(branch => branch.sections.flatMap(section => section.questions.map(question => ({
        ref: questionRef(question), section: section._k, text: (question.text || 'بی‌متن').slice(0, 70),
      }))));
    },
    questionGroups() {
      return Object.values(this.tree.tracks).flatMap(branch => branch.sections).map(section => ({
        key: section._k, label: section.verbose_name || 'بخش', rows: this.questionOptions.filter(row => row.section === section._k),
      })).filter(group => group.rows.length);
    },
  },
  watch: { 'target.item'() { this.focusFirst(); } },
  mounted() { this.focusFirst(); },
  methods: {
    fa,
    focusFirst() { this.$nextTick(() => { if (this.$refs.first && this.item && !this.item.id && this.$refs.first.focus) this.$refs.first.focus(); }); },
    // only one entry photo makes sense; the others lose the role
    toggleEntry(on) {
      if (on) {
        this.photos.forEach(photo => { if (photo !== this.item && photo.name === this.entryPhoto) photo.name = ''; });
        this.previousName = this.item.name;
        this.item.name = this.entryPhoto;
      } else {
        this.item.name = this.previousName && this.previousName !== this.entryPhoto ? this.previousName : '';
      }
    },
  },
};
</script>

<style scoped>
.inspector { display: flex; flex-direction: column; min-height: 0; background: var(--surface); border: 1px solid var(--line); border-radius: var(--r-md); overflow: hidden; }
.ins-head { display: flex; align-items: center; gap: 10px; padding: 12px 14px; background: var(--navy-900); color: #fff; }
.ins-head > div { display: grid; flex: 1; min-width: 0; }
.ins-head small { font-size: 11px; color: var(--shell-text-2); }
.ins-head b { font-size: 13.5px; font-weight: 900; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.ins-kind { width: 34px; height: 34px; display: grid; place-items: center; border-radius: var(--r-xs); background: var(--navy-800); --icon-accent: var(--amber-500); }
.ins-kind.k-question { --icon-accent: var(--teal-500); }
.ins-kind.k-photo { --icon-accent: var(--pink-500); }
.ins-close { width: 32px; height: 32px; display: grid; place-items: center; border: 1px solid var(--shell-line); border-radius: var(--r-xs); background: transparent; color: #fff; cursor: pointer; }
.ins-close:hover { background: var(--navy-800); }
.ins-close .vn-icon { width: 14px; height: 14px; }
.ins-body { flex: 1; overflow-y: auto; padding: 14px; }
</style>
